/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Plannings_StatInputs */



/**
* | output |
* | --- |
* | "Average building occupation" |
*
* @param {Dashboard_Plannings_StatInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const dashboard_plannings_stat = /** @type {((inputs?: Dashboard_Plannings_StatInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Plannings_StatInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Average building occupation")
	return /** @type {LocalizedString} */ ("Occupation moyenne du bâtiment")
});